module.exports = __webpack_public_path__ + "static/media/nuevo.78a9710a.svg";